// Which header menu a page belongs to. The three menu triggers are buttons, so they
// cannot use the router's active link state and read this instead.

export type NavSection = 'Monitoring' | 'Tools' | 'Compare'

const SECTIONS: readonly [NavSection, readonly string[]][] = [
  ['Monitoring', ['features', 'guides', 'integrations', 'docs']],
  ['Tools', ['tools']],
  ['Compare', ['compare', 'alternatives']],
]

export function sectionOf(pathname: string): NavSection | null {
  const first = pathname.split('/')[1] ?? ''
  return SECTIONS.find(([, roots]) => roots.includes(first))?.[0] ?? null
}
